import { useCallback } from 'react';

import { FabricChannel } from '@atlaskit/analytics-listeners';
import { type AnalyticsEventPayload, useAnalyticsEvents } from '@atlaskit/analytics-next';

const ANALYTICS_CHANNEL: FabricChannel.aiMate = FabricChannel.aiMate;
const ANALYTICS_SOURCE = 'conversationAssistantBlankObjectExperience';

/**
 * Hook that returns a function to fire analytics events on the aiMate channel.
 * Automatically injects the package source into every event.
 */
export const useFireAnalyticsEvent = (): {
	fireAnalyticsEvent: (payload: AnalyticsEventPayload) => void;
} => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireAnalyticsEvent = useCallback(
		(payload: AnalyticsEventPayload): void => {
			createAnalyticsEvent({
				...payload,
				source: ANALYTICS_SOURCE,
				attributes: {
					...payload.attributes,
				},
			}).fire(ANALYTICS_CHANNEL);
		},
		[createAnalyticsEvent],
	);

	return { fireAnalyticsEvent };
};
